var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExclamationCircleIcon, ExclamationTriangleIcon } from '@patternfly/react-icons';
import { Button, Icon, Tooltip } from '@patternfly/react-core';
import { css } from '@patternfly/react-styles';
import { createUseStyles } from 'react-jss';
const seconds = 1000;
const minutes = seconds * 60;
const hours = minutes * 60;
const days = hours * 24;
const useStyles = createUseStyles({
    inventoryCullingWarning: {
        color: 'var(--pf-t--global--icon--color--status--warning--default)',
    },
    inventoryCullingDanger: {
        color: 'var(--pf-t--global--icon--color--status--danger--default)',
    },
    iconMargin: {
        marginRight: 'var(--pf-t--global--spacer--sm)'
    },
    messageFont: {
        fontWeight: 'var(--pf-t--global--font--weight--body--bold)',
    },
});
const StaleDataWarning = (_a) => {
    var { culled = new Date(0), className, staleWarning = new Date(0), stale = new Date(0), currDate = new Date(0), children, render, message, "aria-label": ariaLabel } = _a, props = __rest(_a, ["culled", "className", "staleWarning", "stale", "currDate", "children", "render", "message", "aria-label"]);
    const classes = useStyles();
    const calculateTooltip = (culled, warning, currDate) => {
        const culledDate = new Date(culled);
        const warningDate = new Date(warning);
        const diffTime = new Date(currDate).valueOf() - warningDate.valueOf();
        const removeIn = Math.ceil((culledDate.valueOf() - new Date(currDate).valueOf()) / days);
        const msg = message ? message : `System scheduled for inventory removal in ${removeIn} days`;
        if (diffTime >= 0) {
            return {
                isError: true,
                msg,
            };
        }
        return {
            isWarn: true,
            msg,
        };
    };
    if (new Date(currDate).valueOf() - new Date(stale).valueOf() < 0) {
        return render
            ? render({
                msg: '',
            })
            : children || null;
    }
    const { isWarn, isError, msg } = calculateTooltip(culled, staleWarning, currDate);
    if (render) {
        return (_jsxs("span", { className: css({ [classes.inventoryCullingWarning]: isWarn, [classes.inventoryCullingDanger]: isError }, className), children: [isWarn &&
                    _jsx(Icon, { status: "warning", children: _jsx(ExclamationTriangleIcon, { className: css(classes.iconMargin), "aria-label": ariaLabel || "Warning" }) }), isError &&
                    _jsx(Icon, { status: "danger", children: _jsx(ExclamationCircleIcon, { className: css(classes.iconMargin), "aria-label": ariaLabel || "Danger" }) }), _jsx("span", { className: css(classes.messageFont), children: render({ msg }) })] }));
    }
    return (_jsxs(_Fragment, { children: [isError && _jsx(Tooltip, Object.assign({}, props, { content: _jsx("div", { children: msg }), children: _jsx(Button, { variant: "plain", icon: _jsx(Icon, { status: "warning", children: _jsx(ExclamationTriangleIcon, {}) }), "aria-label": ariaLabel || "Warning" }) })), isWarn && _jsx(Tooltip, Object.assign({}, props, { content: _jsx("div", { children: msg }), children: _jsx(Button, { variant: "plain", icon: _jsx(Icon, { status: "danger", children: _jsx(ExclamationCircleIcon, {}) }), "aria-label": ariaLabel || "Danger" }) })), children] }));
};
export default StaleDataWarning;
